import React from 'react';
import AInput from '../../../../../../../../views/pages/manage/common/formFeilds/customInput/AInput';
import { getFormattedAmount } from '../../../../../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod';

const FormField = ({fieldKey, itemKey , handleForm, viewOnly, itemDetails, disabled, disableFormFields}) => {
        const val = itemDetails[fieldKey] || 0;

        return(
            <td>
                {
                    viewOnly
                    ? val
                    : <AInput
                    value={val}
                    handler={val => handleForm(itemKey, fieldKey, +val)}
                    disabled={disabled || disableFormFields}
                />
                }
            </td>
        )
}


const DLPItemDetailsForm = ({
    itemLabel,
    ...rest
}) => {

    const {
        itemsFee ,
        perUnitCost,
        qtyRemaining,
        utilisedAmount
    } = rest?.itemDetails;

    const refundPercentage = rest?.itemDetails?.refundPercentage || 0;


    return (
        <tr>
            <td>{itemLabel}</td>

            <FormField fieldKey={"refundPercentage"} {...rest}/>

            <td>{getFormattedAmount(itemsFee)}</td>

            <FormField fieldKey={"totalQty"} {...rest} disabled={!refundPercentage}/>

            <td>{getFormattedAmount(perUnitCost)}</td>

            <FormField fieldKey={"qtyUtilised"} {...rest} disabled={!refundPercentage}/>

            <td>{qtyRemaining || 0}</td>

            <td><b>{getFormattedAmount(utilisedAmount)}</b></td>

        </tr>
    );
}

export default DLPItemDetailsForm;